import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0159',
    ecrans: ['00-2'],
    params: ['id']
});
